export const PaymentMethods = {
  OTP: 'otp',
  WIRE: 'wire'
}
